import { Link, useLocation } from 'react-router-dom';
import styles from '../styles/Navbar.module.css';

const PAGE_TITLES = {
    '/cv':        'curriculum vitae',
    '/bsc':       'bsc thesis',
    '/playlists': 'playlists',
    '/mc':        'minecraft',
    '/cubeteg':   'cube teg',
    '/ow':        'overwatch trackers · moved',
};

function Navbar() {
    const location = useLocation();
    const path = location.pathname || '/';
    const title = PAGE_TITLES[path] || 'page';

    return (
        <nav className={styles.navbar}>
            <Link to="/" className={styles.brand} aria-label="Back to home">
                ojee<span className={styles.net}>.net</span>
            </Link>
            <span className={styles.live}>live</span>
            <span className={styles.kv}>
                <span className={styles.k}>page</span>
                <span className={styles.v}>{title}</span>
            </span>
            <span className={styles.path}>{path}</span>
            <div className={styles.right}>
                <Link to="/" className={styles.back} aria-label="Back to home">
                    <span className={styles.backArrow}>&lsaquo;</span> back to home
                </Link>
            </div>
        </nav>
    );
}

export default Navbar;
